import React from 'react';
import ReactDOM from 'react-dom';

import { Invite, InviteEmbedOptions } from 'avatar-invite';
import 'avatar-invite/src/Invite.css';

import qs from 'qs';
import { getEnv } from './environment';

function getEmbedOptions(): InviteEmbedOptions {
  const queryParam = getParam('options');
  if (!queryParam) {
    return {} as InviteEmbedOptions;
  }
  return JSON.parse(window.decodeURIComponent(queryParam));
}

function getParam(name: string): string {
  const params = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });

  return params[name] as string;
}

const {
  inviteKey = getParam('inviteKey'),
  avatarDisplayName = process.env.REACT_APP_INVITE_DEFAULT_AVATAR_NAME,
  avatarPictureUrl = process.env.REACT_APP_INVITE_DEFAULT_AVATAR_PICTURE,
  videoUrl = process.env.REACT_APP_INVITE_DEFAULT_VIDEO,
  videoPosterUrl = process.env.REACT_APP_INVITE_DEFAULT_POSTER,
  agreementUrl = process.env.REACT_APP_INVITE_DEFAULT_AGREEMENT,
  extraStylesheet,
} = getEmbedOptions();

async function render() {
  ReactDOM.render(
    <Invite
      inviteKey={inviteKey}
      apiBaseUrl={await getEnv('apiBaseUrl')}
      extraStylesheet={extraStylesheet}
      avatarDisplayName={avatarDisplayName}
      avatarPictureUrl={avatarPictureUrl}
      videoUrl={videoUrl}
      videoPosterUrl={videoPosterUrl}
      agreementUrl={agreementUrl}
    />,
    document.getElementById('root')
  );
}

if (inviteKey) {
  render();
} else {
  throw new Error('Missing inviteKey');
}
